import * as React from 'react';

import { Button, Divider, Form, Typography } from 'antd';

import { CheckOutlinedIcon } from 'components';
import { usePaymentGatewayValue } from 'context';

const PaymentGatewayFormAction = () => {
  const { mode } = usePaymentGatewayValue();

  return (
    <div>
      <div className='px-6 pt-4'>
        <Typography.Title level={3} className='mb-0 text-base font-medium'>
          انتشار درگاه پرداخت
        </Typography.Title>
      </div>

      <Divider className='mb-8 mt-4' />

      <div className='px-6'>
        <Typography.Paragraph>
          از طریق این بخش می‌توانید درگاه پرداخت ساخته شده و یا ویرایش شده را
          منتشر کنید.
        </Typography.Paragraph>
      </div>

      <div className='flex flex-wrap-reverse items-center gap-2 p-6 *:m-0 *:shrink *:grow *:basis-40'>
        <Form.Item>
          <Button
            block
            type='primary'
            htmlType='submit'
            icon={<CheckOutlinedIcon />}
          >
            {mode === 'Create' ? (
              <span>افزودن درگاه پرداخت جدید</span>
            ) : (
              <span>ذخیره تغییرات</span>
            )}
          </Button>
        </Form.Item>
      </div>
    </div>
  );
};

export { PaymentGatewayFormAction };
